import { useQuery } from '@tanstack/react-query';
import { DealerSearch } from './types';
import {
  DealerSearchFormData,
  DealerSearchPayload
} from 'components/associated-dealers/types';
import { getRelativeURLWithParams } from 'utils/url';
import { DEALER_SEARCH } from 'constants/endpoints.api';
import { getRequestId } from 'utils/requestId';
import { REQUEST_ID_HEADER } from 'constants/headers';
import {
  CUSTOMER_NUMBER_INPUT_NAME,
  DEALER_INPUT_ADDRESS,
  DEALER_INPUT_CITY,
  DEALER_INPUT_ZIP_CODE
} from 'components/associated-dealers/constants/constants';

type DealerSearchQuery = {
  data: DealerSearchFormData;
  storeId: string;
};

export const useDealerSearchQuery = ({ data, storeId }: DealerSearchQuery) => {
  return useQuery<DealerSearch>({
    // TODO: dependencies missing in queryKey
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['dealerSearch'],
    queryFn: async () => {
      const url = getRelativeURLWithParams(DEALER_SEARCH, {
        storeId
      });
      const payload: DealerSearchPayload = {
        address: data[DEALER_INPUT_ADDRESS],
        city: data[DEALER_INPUT_CITY],
        customerName: data[CUSTOMER_NUMBER_INPUT_NAME],
        customerNumber: data[CUSTOMER_NUMBER_INPUT_NAME],
        zipcode: data[DEALER_INPUT_ZIP_CODE]
      };

      const response = await fetch(url, {
        method: 'post',
        body: JSON.stringify(payload),
        headers: { [REQUEST_ID_HEADER]: getRequestId() }
      });

      if (response.ok) {
        return response.json();
      } else {
        throw new Error('server error');
      }
    },
    enabled: false
  });
};
